import { defineStore } from 'pinia'
import axios from 'axios'

const axiosInstance = axios.create()
axiosInstance.defaults.headers.common['Accept-Language'] = document?.documentElement.lang ?? 'se'

export const useWebStore = defineStore('ellevio-web', {
  state: () => ({
    headerSearchOpen: false,
    modal: null
  }),

  actions: {
    modalOpen(payload) {
      this.modal = payload
    },
    toggleHeaderSearch() {
      this.headerSearchOpen = !this.headerSearchOpen
    },
    async fetchNewsRoomByFilter(payload) {
      const appendFilter = payload.filter.toLowerCase() !== 'alla' ? `?filter=${payload.filter}` : ''
      const response = await axiosInstance.get(`${payload.apiUrl}${appendFilter}`)
      return response
    }
  }
})
